import * as Configuration from '../../Framework/configuration/index'
import { ReferenceDataState } from "../../../reducers/referenceData.reducer";
import * as DTOS from "../../../FeralScan.dtos";
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { IAppState } from "../../../app";


interface IPlotBadgeContainerActions {
}

interface IPlotBadgeContainerPropsMapped {
    referenceData?: ReferenceDataState;
}

interface IPlotBadgeContainerProps {
    className?: string;
    currentPlot: DTOS.Plot;
}

type PlotBadgeContainerPropsAndActions = IPlotBadgeContainerProps & IPlotBadgeContainerPropsMapped & IPlotBadgeContainerActions;

export interface IPlotBadgeProps {
    className?: string;
    referencePlotStatus: DTOS.PlotStatus[];
    plot: DTOS.Plot;
}

class PlotBadgeContainer extends React.Component<PlotBadgeContainerPropsAndActions, any> {
    constructor(props: PlotBadgeContainerPropsAndActions, context) {
        super(props, context);
    }

    render() {
        
        const Component = Configuration.AppConfig.plotBadgeComponent;

        return <Component
            className={this.props.className}
            plot={this.props.currentPlot}
            referencePlotStatus={this.props.referenceData.plotStatuses}
        />;
    }
}


const mapStateToProps = (state: IAppState, ownProps: PlotBadgeContainerPropsAndActions): IPlotBadgeContainerPropsMapped => {

    return {
        referenceData: state.referenceData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
    }, dispatch)
}

export default connect(mapStateToProps,mapDispatchToProps)(PlotBadgeContainer);